import { SettingConst } from '@faire/web-api--source/types';

/**
 * If enabled, the FD FOI modal is popped on session start and then the site wide FOI modal is popped on page nav
 * Notion: https://www.notion.so/faire/FOI-for-FD-Sequential-Modals-2142efb5c25a805ab4f4d8c0c39170d2
 */
export const FOI_FOR_FD_SEQUENTIAL_MODALS_250623 =
  'FOI_FOR_FD_SEQUENTIAL_MODALS_250623' as SettingConst<
    'FOI_FOR_FD_SEQUENTIAL_MODALS_250623',
    boolean,
    'RETAILER'
  >;
